import { Link } from 'react-router-dom'
import { useT } from '../i18n'

export interface Krumen {
  name: string
  pfad?: string
}

/** Zeigt, wo man ist — und lässt eine Ebene zurück, ohne den Zurückknopf. */
export function Breadcrumbs({ pfade }: { pfade: Krumen[] }) {
  const t = useT()
  return (
    <nav className="krumen" aria-label={t('krumen.aria')}>
      <ol>
        {pfade.map((krume, index) => (
          <li key={`${krume.name}-${index}`}>
            {krume.pfad ? (
              <Link to={krume.pfad}>{krume.name}</Link>
            ) : (
              <span aria-current="page">{krume.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
